<template lang="pug">
.input-wrapper
  label.label {{ label }}
  input.input(
    @input="inputed"
    :type="type"
    :disabled="disabled"
    :placeholder="placeholder"
    :value="value"
  )
</template>
<script>
export default {
  name: 'GbInput',
  props: {
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String | Number,
      required: true
    },
    validation: {
      type: Function,
      default: null,
      required: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInvalid: false
    }
  },
  computed: {
  },
  methods: {
    inputed ($e) {
      this.$emit('input', $e.target.value)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../../stylus/main.styl'
.input-wrapper
  display flex
  flex-direction column
  justify-content center
  align-items stretch
  margin 8px 0
.label
  font-size 12px
  color $color-secondary
  margin 0 8px
.input
  border none
  outline none
  height 30px
  width 400px
  border-radius 4px
  margin 8px
  padding 0 8px
  background-color $color-gray
  font-size 14px
  transition-duration .2s
  &:focus
    background-color #fff
    box-shadow 0 2px 4px rgba(42, 54, 63, 0.2)
</style>



// WEBPACK FOOTER //
// src/components/atoms/GbInput.vue